/*
replaceCTAPanelData('cta-panel--default', {
  image_url: 'https://www.kingsford.com/wp-content/uploads/2022/01/KFD_PtP22_siteTile_TheGuys_raw.png',
  imageMobile_url: 'https://www.kingsford.com/wp-content/uploads/2022/01/KFD_PtP22_siteTile_TheGuys_raw.png',
  title: 'title',
  subtitle: 'subtitle',
  cta_link: 'https://google.com/',
  cta_text: 'cta text',
  cta_variant: 'primary',
});
*/

import {buttonFilledSvg, buttonOutlineSvg} from "../app";

function replaceCTAPanelData(id, data) {
    try {
        const section = document.getElementById(id);
        setBackgroundImage(section, data.image_url);
        setBackgroundImageMobile(section, data.imageMobile_url);
        setTitle(section, data.title);
        setSubtitle(section, data.subtitle);
        setCTA(section, {
            ctaLink: data.cta_link,
            ctaText: data.cta_text,
            // TODO: Enable the variant to be set from the data, when it is implemented in the cms
            // ctaVariant: data.cta_variant,
            ctaVariant: 'white',
        });
    } catch (error) {
        console.error(error);
    }
}

const setBackgroundImage = (section, value) => {
    const picture = section.querySelector('picture');
    if (picture) {
        const desktopSource = picture.querySelector('source[media="(min-width:768px)"]');
        const img = picture.querySelector('img');
        if (desktopSource) {
            desktopSource.srcset = value;
        }
        if (img) {
            img.src = value;
        }
    }
};

const setBackgroundImageMobile = (section, value) => {
    const picture = section.querySelector('picture');
    if (picture) {
        const mobileSource = picture.querySelector('source[media="(max-width:767px)"]');
        if (mobileSource) {
            mobileSource.srcset = value;
        }
    }
};

const setTitle = (section, value) => {
    const element = section.querySelector('.b-cta-panel__info-wrapper__title');
    element.innerHTML = value;
};

const setSubtitle = (section, value) => {
    const element = section.querySelector('.b-cta-panel__info-wrapper__subtitle');
    element.innerHTML = value;
};

const setCTA = (section, value) => {
    const element = section.querySelector('.b-cta-panel__button-wrapper');
    element.innerHTML = `
    <a class="e-button e-button--${value.ctaVariant} e-button--large" href="${value.ctaLink}" target="_self">
      <span class="e-button__background outline">${buttonOutlineSvg}</span>
      <span class="e-button__background filled">${buttonFilledSvg}</span>
      <span class="e-button__copy">${value.ctaText}</span>
    </a>
  `;
};

window.replaceCTAPanelData = replaceCTAPanelData;
